<script>
    export let progress = 0; 
</script>


<div class="progress-bar">
    <div class="progress-bar-fill" style="width: {progress}%;">{progress}%</div>
</div>
